// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyCreateV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyCreateV2WebApiHandler_create } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyCreateResponseV2WebDto,
  UserPropertyCreateV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyCreateV2WebApiHandler_create_Args {
  postData: UserPropertyCreateV2RequestDto;
}

export type RentalManagerUserPropertyCreateV2WebApiHandler_create_Options = UseMutationOptions<
  UserPropertyCreateResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyCreateV2WebApiHandler_create_Args
>;

/**
 * Create a property for the user
 */
export const useRentalManagerUserPropertyCreateV2WebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyCreateV2WebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyCreateV2WebApiHandler_create_Args) =>
      RentalManagerUserPropertyCreateV2WebApiHandler_create(args.postData, httpClient),
  });
};
